export const servicesQuery = `{
  services {
    id
    code
    name
  }
}`
